import { render, staticRenderFns } from "./DetailAbout.vue?vue&type=template&id=48533562&scoped=true&"
import script from "./DetailAbout.vue?vue&type=script&lang=js&"
export * from "./DetailAbout.vue?vue&type=script&lang=js&"
import style0 from "./DetailAbout.vue?vue&type=style&index=0&id=48533562&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48533562",
  null
  
)

export default component.exports